/**
 * MurmurHash3 구현 (32비트)
 *
 * 사용자 ID와 피처 플래그 이름을 조합하여 일관된 해시값을 생성합니다.
 * 이를 통해 동일한 사용자가 항상 동일한 피처 플래그 그룹에 할당됩니다.
 *
 * @see http://github.com/garycourt/murmurhash-js
 * @author Gary Court
 */

export function murmurhash(key: string): number {
    const remainder = key.length & 3;
    const bytes = key.length - remainder;
    const c1 = 0xcc9e2d51;
    const c2 = 0x1b873593;

    let h1 = 0;
    let i = 0;

    while (i < bytes) {
        let k1 =
            (key.charCodeAt(i) & 0xff) |
            ((key.charCodeAt(++i) & 0xff) << 8) |
            ((key.charCodeAt(++i) & 0xff) << 16) |
            ((key.charCodeAt(++i) & 0xff) << 24);
        ++i;

        k1 =
            ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) &
            0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 =
            ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) &
            0xffffffff;

        h1 ^= k1;
        h1 = (h1 << 13) | (h1 >>> 19);
        const h1b =
            ((h1 & 0xffff) * 5 + ((((h1 >>> 16) * 5) & 0xffff) << 16)) &
            0xffffffff;
        h1 =
            (h1b & 0xffff) +
            0x6b64 +
            ((((h1b >>> 16) + 0xe654) & 0xffff) << 16);
    }

    let k2 = 0;

    switch (remainder) {
        case 3:
            k2 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            k2 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            k2 ^= key.charCodeAt(i) & 0xff;

            k2 =
                ((k2 & 0xffff) * c1 + ((((k2 >>> 16) * c1) & 0xffff) << 16)) &
                0xffffffff;
            k2 = (k2 << 15) | (k2 >>> 17);
            k2 =
                ((k2 & 0xffff) * c2 + ((((k2 >>> 16) * c2) & 0xffff) << 16)) &
                0xffffffff;
            h1 ^= k2;
    }

    h1 ^= key.length;

    h1 ^= h1 >>> 16;
    h1 =
        ((h1 & 0xffff) * 0x85ebca6b +
            ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) &
        0xffffffff;
    h1 ^= h1 >>> 13;
    h1 =
        ((h1 & 0xffff) * 0xc2b2ae35 +
            ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16)) &
        0xffffffff;
    h1 ^= h1 >>> 16;

    return h1 >>> 0;
}
